import AppUserService from 'src/modules/appUser/appUserService';
import selectors from 'src/modules/appUser/list/appUserListSelectors';
import { i18n } from 'src/i18n';
import exporterFields from 'src/modules/appUser/list/appUserListExporterFields';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';

const prefix = 'APPUSER_LIST';

const appUserListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,
  SELECTEDS_CHANGED: `${prefix}_SELECTEDS_CHANGED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  TEMPLATES_FETCH_STARTED: `${prefix}_TEMPLATES_FETCH_STARTED`,
  TEMPLATES_FETCH_SUCCESS: `${prefix}_TEMPLATES_FETCH_SUCCESS`,
  TEMPLATES_FETCH_ERROR: `${prefix}_TEMPLATES_FETCH_ERROR`,

  doFetchTemplates: () => async (dispatch) => {
    try {
      dispatch({
        type: appUserListActions.TEMPLATES_FETCH_STARTED,
      });

      const rows = await AppUserService.listTemplates();

      dispatch({
        type: appUserListActions.TEMPLATES_FETCH_SUCCESS,
        payload: rows || [],
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: appUserListActions.TEMPLATES_FETCH_ERROR,
      });
    }
  },

  doChangeSelected(payload) {
    return {
      type: appUserListActions.SELECTEDS_CHANGED,
      payload,
    };
  },

  doReset: () => async (dispatch) => {
    dispatch({
      type: appUserListActions.RESETED,
    });

    dispatch(appUserListActions.doFetch());
  },

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: appUserListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await AppUserService.list(
        filter,
        selectors.selectOrderBy(getState()),
        null,
        null,
      );

      new Exporter(
        exporterFields,
        i18n('entities.appUser.exporterFileName'),
      ).transformAndExportAsExcelFile(response.rows);

      dispatch({
        type: appUserListActions.EXPORT_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: appUserListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePaginationAndSort: (pagination, sorter) => async (
    dispatch,
    _getState,
  ) => {
    dispatch({
      type: appUserListActions.PAGINATION_CHANGED,
      payload: pagination,
    });

    dispatch({
      type: appUserListActions.SORTER_CHANGED,
      payload: sorter,
    });

    dispatch(appUserListActions.doFetchCurrentFilter());
  },

  doFetchCurrentFilter: () => async (
    dispatch,
    getState,
  ) => {
    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    dispatch(appUserListActions.doFetch(filter, rawFilter, true));
  },

  doFetch: (filter?, rawFilter?, keepPagination = false) => async (
    dispatch,
    getState,
  ) => {
    try {
      dispatch({
        type: appUserListActions.FETCH_STARTED,
        payload: { filter, rawFilter, keepPagination },
      });

      const response = await AppUserService.list(
        filter,
        selectors.selectOrderBy(getState()),
        selectors.selectLimit(getState()),
        selectors.selectOffset(getState()),
      );

      dispatch({
        type: appUserListActions.FETCH_SUCCESS,
        payload: {
          rows: response.rows,
          count: response.count,
        },
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: appUserListActions.FETCH_ERROR,
      });
    }
  },
};

export default appUserListActions;
